<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">单位管理</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="mb-2">
									<span>单位名称：</span>
									<el-input v-model="query.name" placeholder="请输入单位名称" class="mr-3" style="width: 180px"></el-input>
									<span>区域：</span>
									<el-cascader :options="areaOptions" :props="{ expandTrigger: 'hover', label: 'name', value: 'id' }" clearable filterable @change="cascaderChange">
										<template slot-scope="{ node, data }">
											<span>{{ data.name }}</span>
											<span v-if="!node.isLeaf">({{ data.children.length }})</span>
										</template>
									</el-cascader>
									<span>单位类别：</span>
									<el-select v-model="query.type" clearable placeholder="请选择">
										<el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
									<el-button class="ml-2 mr-2" type="success" @click="getData">查询</el-button>
									<el-button type="primary" style="font-size:17px" icon="el-icon-edit" @click="toUpdate(false, 'add')">新建单位</el-button>
								</div>
								<el-table ref="table" v-loading="loading" :data="list" style="width: 100%" border :header-cell-style="tableHeaderStyle">
									<el-table-column label="单位名称" min-width="200">
										<template slot-scope="scope">
											{{ scope.row.unitName }}
										</template>
									</el-table-column>
									<el-table-column prop="regionName" label="所属区域" min-width="150"></el-table-column>
									<!--  show-overflow-tooltip  -->
									<el-table-column prop="type" label="类别">
										<template slot-scope="scope">
											{{ getType(scope.row.type) }}
										</template>
									</el-table-column>
									<el-table-column prop="dateTime" label="创建时间" min-width="120"></el-table-column>
									<el-table-column prop="userNum" label="人员数量" min-width="120"></el-table-column>
									<el-table-column label="操作" width="150">
										<template slot-scope="scope">
											<el-button type="primary" size="small" @click="toUpdate(scope.row, 'update')">修改</el-button>
											<el-button type="danger" size="small" @click="toUpdate(scope.row, 'del')">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination background layout="total, prev, pager, next" :page-size="query.pageSize" :total="total" @current-change="handlePageChange"></el-pagination>
								</div>
								<el-dialog :title="isAdd ? '添加单位信息' : '修改单位信息'" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="right">
										<el-form-item label="单位名称:" prop="unitName"><el-input v-model="ruleForm.unitName"></el-input></el-form-item>
										<el-form-item label="所属区域:" prop="regionId">
											<el-cascader
												v-model="cascaderModel"
												:options="areaOptions"
												:props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
												clearable
												filterable
												@change="
													e => {
														cascaderChange(e, 'form');
													}
												"
											>
												<template slot-scope="{ node, data }">
													<span>{{ data.name }}</span>
													<span v-if="!node.isLeaf">({{ data.children.length }})</span>
												</template>
											</el-cascader>
										</el-form-item>
										<el-form-item label="单位类型:" prop="type">
											<el-select v-model="ruleForm.type" placeholder="请选择">
												<el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="地址:" prop="address"><el-input v-model="ruleForm.address"></el-input></el-form-item>

										<el-form-item label="电话:" prop="phone"><el-input v-model="ruleForm.phone"></el-input></el-form-item>

										<el-form-item label="简介:" prop="intro">
											<el-input type="textarea" v-model="ruleForm.intro" autosize :rows="4" :maxlength="2000" placeholder="请输入..."></el-input>
											<span>（2000字以内）</span>
										</el-form-item>
										<el-form-item class="flex_end_x">
											<el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
											<el-button @click="dialogFormVisible = false">返回</el-button>
										</el-form-item>
									</el-form>
								</el-dialog>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getUnitList, getUnitDetail, getAreaTree, deleteUnit, addUnit, updateUnit, getPlatformInformationData } from '@/api/after/systemManagement';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	name: 'unitManagement',
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableHeaderStyle: {
				backgroundColor: '#3083c5',
				color: '#fff'
			},
			cascaderModel: [], //表单区域默认值
			dialogFormVisible: false,
			list: [],
			areaOptions: [],
			typeOptions: [], //单位类型列表
			query: {
				id: null,
				type: '',
				name: '',
				pageNumber: 1,
				pageSize: 10,
				pageSorts: [{ asc: true, column: '' }]
			},
			total: 0,
			ruleForm: {},
			rules: {
				unitName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }, { max: 40, message: '单位名称在40个字符以下', trigger: 'blur' }],
				regionId: [{ required: true, message: '请选择区域', trigger: 'change' }],
				type: [{ required: true, message: '请选择单位类型', trigger: 'change' }]
			},
			isAdd: true, //是否添加状态
			loading:false
		};
	},
	computed: {
		getType(val) {
			return val => {
				if (isNaN(+val)) {
					return val;
				} else {
					let obj = this.typeOptions.find(item => {
						return item.id == val;
					});
					return obj.name;
				}
			};
		}
	},
	mounted() {
		this.getData();
		this.getAreaTree();
		this.getUnitType();
	},
	methods: {
		// 获取数据列表
		getData() {
			this.loading = true
			getUnitList(this.query).then(res => {
				if (res.code == 200) {
					this.list = res.data.records;
					this.total = res.data.total;
					this.loading = false
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取详情信息
		getDetail(id) {
			getUnitDetail(id).then(res => {
				if (res.code == 200) {
					this.ruleForm = res.data;
					this.ruleForm.type = parseInt(this.ruleForm.type);
					if (res.data.parentIds) {
						this.cascaderModel = res.data.parentIds;
						// this.cascaderModel = ["1","2"];
					}
					this.dialogFormVisible = true;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取类型列表
		getUnitType() {
			getPlatformInformationData(9).then(res => {
				if (res.code == 200) {
					this.typeOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		getAreaTree() {
			getAreaTree().then(res => {
				if (res.code == 200) {
					this.areaOptions = res.data;
				} else {
					this.$message.error(res.data);
				}
			});
		},
		//区域查询
		cascaderChange(e, name) {
			let num = 0;
			e.length <= 0 ? (num = 0) : (num = e[e.length - 1]);
			if (name == 'form') {
				this.ruleForm.regionId = num;
			} else {
				this.query.id = num;
			}
		},
		toUpdate(data, name) {
			this.cascaderModel = [];
			if (name == 'del') {
				if (data.userNum > 0) {
					this.$message.warning('该单位下有用户不能删除');
					return;
				}
				this.$confirm('确定要将该单位删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'error'
				}).then(() => {
					this.deleteData(data.id);
				});
			} else if (name == 'update') {
				this.isAdd = false;
				this.getDetail(data.id);
			} else if (name == 'add') {
				this.isAdd = true;
				this.ruleForm = {
					unitName: '',
					regionId: null,
					address: '',
					intro: '',
					phone: '',
					type: null
				};
				this.dialogFormVisible = true;
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.isAdd ? this.addData() : this.updateData();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 删除
		deleteData(id) {
			deleteUnit(id).then(res => {
				if (res.code == 200) {
					this.$message.success('删除成功');
				} else {
					this.$message.error(res.data);
				}
				this.getData();
			});
		},
		// 添加
		addData() {
			addUnit(this.ruleForm).then(res => {
				if (res.code == 200) {
					this.$message.success('添加成功');
				} else {
					this.$message.error(res.data);
				}
				this.dialogFormVisible = false;
				this.getData();
			});
		},
		//修改
		updateData() {
			updateUnit(this.ruleForm).then(res => {
				if (res.code == 200) {
					this.$message.success('修改成功');
				} else {
					this.$message.error(res.data);
				}
				this.dialogFormVisible = false;
				this.getData();
			});
		},
		// 分页导航
		handlePageChange(val) {
			this.query.pageNumber = val;
			this.getData();
		}
	}
};
</script>
<style scoped>
.wrap {
	background: #fafbfe;
	padding: 30px;
}
.con {
	min-height: 500px;
	background: #fff;
	padding: 30px;
	border-radius: 5px;
}
/deep/.el-table th > .cell {
	text-align: center;
}

/deep/.el-table .cell {
	text-align: center;
}
</style>
